import React from "react";
import { MessageCircle } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

const WHATSAPP_URL = "https://wa.me/919502900360?text=Hi%20Avaginja%2C%20I%27d%20like%20to%20know%20more.";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-border bg-secondary text-secondary-foreground">
      <div className="mx-auto max-w-7xl px-6 py-12 grid gap-8 sm:grid-cols-3">
        <div>
          <BrandMark dark iconSize={40} />
          <p className="mt-4 font-heading font-semibold text-secondary-foreground/90">Trade. Earn. Shop. Grow.</p>
          <p className="mt-2 text-sm text-secondary-foreground/70 max-w-xs">
            From seed to shelf to wardrobe — shop rice, grains & pulses, trade your old rice and earn rewards across Hyderabad.
          </p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-btn"
             className="mt-5 inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold text-sm px-4 py-2.5 rounded-lg hover:opacity-90 transition-opacity">
            <MessageCircle size={16} /> Chat with us on WhatsApp
          </a>
        </div>
        <div className="text-sm">
          <div className="font-semibold mb-3">How Rewards Work</div>
          <p className="text-secondary-foreground/70">Trade eligible household rice at 1 kg = ₹10 RicePoints, then use up to 15% of your next eligible order value.</p>
        </div>
        <div className="text-sm">
          <div className="font-semibold mb-3">Note</div>
          <p className="text-secondary-foreground/70">Final RicePoints are calculated after physical weighing and acceptance. Collected household rice is segregated and handled per applicable food-safety rules.</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-secondary-foreground/60">
        © 2026 Avaginja · ఆవగింజ · Hyderabad, India
      </div>
    </footer>
  );
}
